<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">

    {{dep}}
    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th>編號</th>
        <th>姓名</th>
        <th>備註</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td class="text-left">
          001
        </td>
        <td class="text-left">
          <button class="btn btn-primary" @click="goto()" >楊清壬</button>
        </td>
        <td class="text-left">
          <button class="btn btn-info" @click="changeDetail()">顯示 摘要資訊</button>
          <table class="table table-hover" v-if="showDetail">
            <thead class="thead-light">
            <tr>
              <th>科別</th>
              <th>事項</th>
              <th>追蹤建議</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>泌尿科</td>
              <td></td>
              <td>每三個月追蹤腎臟功能</td>
            </tr>
            <tr>
              <td>神經外科</td>
              <td></td>
              <td>必要時</td>
            </tr>
            <tr>
              <td>骨科</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>復健科</td>
              <td></td>
              <td>
                建議持續復健
                可改善T6/T7 肌力
                可進一步加強平衡
              </td>
            </tr>
            <tr>
              <td>中醫科</td>
              <td></td>
              <td>可持續改善</td>
            </tr>
            <tr>
              <td>牙科</td>
              <td></td>
              <td>必要時</td>
            </tr>
            <tr>
              <td>整形外科</td>
              <td></td>
              <td>必要時/建議盡快手術處理</td>
            </tr>

            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td class="text-left">
          001
        </td>
        <td class="text-left">
          <button class="btn btn-primary" @click="goto()" >王大明</button>
        </td>
        <td class="text-left">
        </td>
      </tr>
      <tr>
        <td class="text-left">
          001
        </td>
        <td class="text-left">
          <button class="btn btn-primary" @click="goto()" >陳上海</button>
        </td>
        <td class="text-left">
        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    dep:{
      type: String,
      default() {
        return ""
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      showDetail:false,
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    goto(){
      this.$router.push({ name: 'RCCEditFreeClinic', query: { dep: this.dep }})
    },
    changeDetail(){
      this.showDetail=!this.showDetail;
    }
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
